module.exports = __webpack_public_path__ + "img/2762a42a3d64401340352781d28481451468.5adb8281.jpg";